module.exports = __webpack_public_path__ + "images/homepage-mobile-icon.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-mobile-icon.png
// module id = 848
// module chunks = 0